import axios from 'axios'

// 创建axios实例
const service = axios.create({
    baseURL: 'https://sound.alonedream.com/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 添加token
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        
        return config
    },
    error => {
        // 对请求错误做些什么
        console.error('Request Error:', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        console.log('Response:', response)
        
        // 隐藏loading
        // console.log('Hide loading...')
        
        const { data } = response
        
        // 根据后端返回的状态码判断请求是否成功
        if (data.code === 200 || data.code === 0) {
            return data
        } else if (data.code === 401) {
            // 清除token并跳转到登录页
            localStorage.removeItem('token')
            window.location.href = '/login'
        } else {
            // 处理业务错误
            console.error('Business Error:', data.msg)
            return Promise.reject(new Error(data.msg || '请求失败'))
        }
    },
    error => {
        // 对响应错误做点什么
        console.error('Response Error:', error)
        
        // 隐藏loading
        // console.log('Hide loading...')
        
        let message = '网络错误'
        
        if (error.response) {
            // 服务器返回了错误状态码
            const { status, data } = error.response
            
            switch (status) {
                case 401:
                    message = '未授权，请重新登录'
                    // 清除token并跳转到登录页
                    localStorage.removeItem('token')
                    // window.location.href = '/login'
                    break
                case 403:
                    message = '拒绝访问'
                    break
                case 404:
                    message = '请求地址出错'
                    break
                case 500:
                    message = '服务器内部错误'
                    break
                default:
                    message = data.message || `请求失败: ${status}`
            }
        } else if (error.request) {
            // 请求已发出但没有收到响应
            message = '网络连接失败'
        } else {
            // 请求配置出错
            message = error.message
        }
        
        // 这里可以调用Vue的消息提示组件
        console.error('Error Message:', message)
        
        return Promise.reject(error)
    }
)

// 封装GET请求
export const get = (url, params = {}, config = {}) => {
    return service.get(url, {
        params,
        ...config
    })
}

// 封装POST请求
export const post = (url, data = {}, config = {}) => {
    return service.post(url, data, config)
}

// 封装PUT请求
export const put = (url, data = {}, config = {}) => {
    return service.put(url, data, config)
}

// 封装DELETE请求
export const del = (url, config = {}) => {
    return service.delete(url, config)
}

// 封装上传文件
export const upload = (url, file, config = {}) => {
    const formData = new FormData()
    formData.append('file', file)
    
    return service.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        ...config
    })
}

// 导出axios实例
export default service




// WEBPACK FOOTER //
// ./src/util/axios.js